import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import {
    Link, useLocation, useNavigate, useParams
} from "react-router-dom";
import Breadcrumb from '../../Components/Breadcrumb';
import ReductionForm from './form';
import ReductionService from './service';
import ClientService from './service';


const ReductionEdit: FC = () => {  
    const location: any = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const reductionService = new ReductionService();

    let { id } = useParams();

    const [reduction, setReduction] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        reductionService.getReduction(Number(id)).then(async function (response: any) {
            console.log(response); 
            setReduction(response.data.promo);
            setLoading(false); 
        })
          .catch(function (error: any) {
            console.log(error);
            setLoading(false); 
        });
    }, []);

    return ( 
        <> 
            <Breadcrumb />

            <div className="container-fluid">

                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">
                                    { t('Modifier une reduction') }
                                </h4>
                                <Link type="button" to="/reduction/list"
                                    className="btn waves-effect waves-light btn-primary">
                                        { t('Liste des reductions') } 
                                </Link>
                                <br />
                                <br />

                                { !loading && reduction ?
                                    <ReductionForm state='edit' reduction={ reduction } />  
                                    :
                                    <div className="spinner-border text-primary spinner-border-lg" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                }     
                                 
                                </div>
                            </div> 
                    </div> 
                </div>

            </div>   
        </>                   
    );
}

export default ReductionEdit